import {
  CHARGER_TYPE_STANDARD,
  ChargeSupplyTransactions,
  ChargerDivision,
  CsupCsvData,
} from "@/models/chargeSupplyTransaction";
import { formatKwh } from "@/util";

export const ChargeTransactionConstants = {
  SupplyTransaction: "充電履歴",
  TargetDate: "対象年月日",
  OfficeName: "会社／営業所",
  Vehicle: "車両",
  ChargeStartDatetime: "充電開始日時",
  ChargeEndDatetime: "充電終了日時",
  ChargeType: "充電種別",
  ChargerName: "充電器名",
  ChargeCardNumber: "充電カード管理番号",
  VehicleTypeName: "車種名",
  VehicleInfo: "車両情報",
  ChargeElectricPower: "充電電力量\n（kWh）",
  RadioNumber: "無線番号",
  CsvDownloadNote: "※検索結果が100,000件を超えてのダウンロードはできません\n※CSV作成には、最長で20秒程度要することがあります",
} as const;

export const getIfChargerTypeQuick = <T>(
  supplyTransaction: ChargeSupplyTransactions,
  value: T | undefined
) => {
  if (supplyTransaction.type === CHARGER_TYPE_STANDARD) {
    return undefined;
  }

  return value;
};

export const CsvHeader = [
  ChargeTransactionConstants.OfficeName,
  ChargeTransactionConstants.ChargeStartDatetime,
  ChargeTransactionConstants.ChargeEndDatetime,
  ChargeTransactionConstants.ChargeType,
  ChargeTransactionConstants.ChargerName,
  ChargeTransactionConstants.ChargeCardNumber,
  ChargeTransactionConstants.VehicleTypeName,
  ChargeTransactionConstants.RadioNumber,
  ChargeTransactionConstants.ChargeElectricPower.replace("\n", ""),
];

export const generateCsvFileName = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `充電実績一覧_${year}${month}${day}_${hour}${minute}.csv`;
};

export const CSV_DOWNLOAD_LIMIT = 100000;

export const formatDate = (v: string): string => {
  return v.slice(0, 16).replaceAll("-", "/").replace("T", " ");
};

// CSVデータ生成関数
export const generateCsvData = (data: CsupCsvData[]): string => {
  // CSVデータ行の生成
  const csvRows = data.map((row) => [
    row.displayName,
    formatDate(row.startAt),
    formatDate(row.endAt),
    ChargerDivision[Number(row.type)],
    row.chargerName,
    row.chargeCardManagementNumber ?? "ー",
    row.evCarModelName ?? "ー",
    row.vehicleCode ?? "ー",
    formatKwh(row.chargeKwh),
  ]);

  // CSVコンテンツの作成
  return [CsvHeader, ...csvRows]
    .map((row) => row.map((field) => `"${field}"`).join(","))
    .join("\n");
};
